import { useEffect, useState } from 'react';
const _userRepo = {};
const UserInfo = (props: {
  webApi: any;
  userId: number;
}) => {
  const [userRepo, setUserRepo] = useState<Record<number, any>>({});
  const { userId, webApi } = props;
  useEffect(() => {
    askUserInfo();
  }, [userId]);
  const askUserInfo = () => {
    if (!userId) return;
    if (!_userRepo[userId]) {
      webApi.getUser(userId).ajax()
        .then((res: any) => {
          if (res) {
            _userRepo[res.userId] = res;
            setUserRepo(_userRepo);
          }
        });
    } else {
      if (!userRepo[userId]) {
        setUserRepo(_userRepo);
      }
    }
  };
  return userRepo[userId]?.displayName || '-';
};

export default UserInfo;
